import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

import {Headline} from 'src/admin-rights-service/components/headline';
import {Skeleton} from 'src/components/skeleton';

import Button from '@pb/kit-component-button';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import Icon, {Icons} from '@pb/kit-component-icon';


import {AssignedUsersHeadlineSkeleton} from './assigned-users-headline.skeleton';

type Props = {
    isLoading: boolean,
    profileName: string,
    onAddUser: () => void,
};
export const AssignedUsersHeadline = ({onAddUser, profileName, isLoading}: Props) => {
    const navigate = useNavigate();

    const backToRoles = useCallback(() => {
        navigate('/roles/');
    }, [navigate]);

    return (
        <Skeleton shown={isLoading} view={<AssignedUsersHeadlineSkeleton/>}>
            <Headline
                prefix={(
                    <Button
                        variant="Type.SECONDARY"
                        startIcon={<Icon type={Icons.ANGLE_LEFT}/>}
                        onClick={backToRoles}>
                        Back to Roles
                    </Button>
                )}
                header={(
                    <div style={{maxWidth: 700}}>
                        <EllipsisTextHint title={profileName}>
                            {profileName}
                        </EllipsisTextHint>
                    </div>
                )}
                actionButtons={
                    <Button variant="Type.PRIMARY" onClick={onAddUser}>Add Users</Button>
                }
            />
        </Skeleton>
    );
};
